<template>
    <b-modal
        ref="mainModal"
        @ok="saveHandler()"
        :title="`Editing component ${model.id} (UID: ${model.uid})`"
        size="lg"
    >
        <!-- <b-form-group :label="`UID: ${model.uid}`" class="mb-3"> </b-form-group> -->
        <b-form-group label="Identifier" class="mb-3">
            <b-input v-model="model.id"></b-input>
        </b-form-group>
        <b-form-group label="Tag" class="mb-3">
            <b-input v-model="model.tag"></b-input>
        </b-form-group>
        <b-form-group label="Routable" class="mb-3" v-if="showMore">
            <b-checkbox v-model="model.isRoutable"
                >use as routable component</b-checkbox
            >
            <b-form-group
                label="Route on which this component will be rendered"
                v-if="model.isRoutable"
            >
                <b-input
                    v-model="model.route"
                    placeholder="enter 'example-page' and it will be accesable as https://somedomain/example-page"
                ></b-input>
            </b-form-group>
            <b-form-group label="Navigation link" v-if="model.isRoutable">
                <b-input
                    v-if="model.isRoutable"
                    v-model="model.routeLink"
                    placeholder="enter 'Example page' and it will be added to navigation"
                ></b-input>
            </b-form-group>
        </b-form-group>
        <b-form-group label="Slots" class="mb-3" v-if="showMore">
            <div class="d-flex w-100">
                <a
                    href="#"
                    variant="link"
                    @click.prevent="expandSlots = !expandSlots"
                    class="ml-auto small"
                    >{{ dbg ? "Hide" : "Show" }} slots info</a
                >
            </div>
            <!-- @todo: make some UI for managing slots -->
            <!-- <b-input v-model="model.slots"></b-input> -->
            <pre v-if="expandSlots" class="bg-light rounded border p-1">{{
                model.slots
            }}</pre>
        </b-form-group>
        <b-form-group label="Events" class="mb-3">
            <!-- @todo: make some UI for managing events -->
            <!-- <b-input v-model="model.events"></b-input> -->
            <pre class="bg-light rounded border p-1">{{ model.events }}</pre>
        </b-form-group>

        <label><strong>Component importing and registration</strong></label>

        <b-form-group class="mb-3" label="Import as">
            <!-- @todo: this should be locked out - there is no point to change it, pick another component instead -->
            <b-form-radio-group
                v-model="model.importAs"
                :options="importOptions"
                name="radio-inline"
            ></b-form-radio-group>
        </b-form-group>
        <template v-if="showMore">
            <b-form-group label="Import name" class="mb-3">
                <b-input v-model="model.importName"></b-input>
            </b-form-group>
            <b-form-group label="Import path" class="mb-3">
                <b-input v-model="model.importPath"></b-input>
            </b-form-group>
            <b-form-group label="Import result" class="mb-3">
                <span>{{
                    `import ${
                        model.importAs === "lib"
                            ? "{ " + model.importName + " }"
                            : model.importName
                    } from "${
                        model.importAs === "local"
                            ? componentImportBase + model.importPath
                            : model.importPath
                    }";`
                }}</span>
            </b-form-group>
        </template>
        <template v-if="model.importAs === 'inline'">
            <b-form-group label="Self closing tag" class="mb-3">
                <b-checkbox v-model="model.selfClosing"
                    >self closing tag</b-checkbox
                >
            </b-form-group>
        </template>
        <div class="d-flex w-100">
            <a
                href="#"
                variant="link"
                @click.prevent="dbg = !dbg"
                class="ml-auto small"
                >{{ dbg ? "Hide" : "Show" }} debug info</a
            >
        </div>
        <pre v-if="dbg" class="bg-light rounded border p-1">{{ model }}</pre>
    </b-modal>
</template>
<script>
export default {
    name: "ComponentEditor",
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        componentImportBase: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            model: {},
            importOptions: [
                { text: "own component in project", value: "local" },
                { text: "seperate dependency", value: "module" },
                { text: "as part of the library", value: "lib" },
                { text: "as basic html tag", value: "inline" },
                { text: "text only", value: "text" }
            ],
            dbg: false,
            expandSlots: false
        };
    },
    computed: {
        showMore() {
            return this.model.importAs === "inline" ||
                this.model.importAs === "text"
                ? false
                : true;
        }
    },
    methods: {
        laodEntry(value) {
            if (Object.keys(value).length) {
                this.model = Object.assign({}, value);
            }
        },
        open() {
            this.laodEntry(this.value);
            this.$refs.mainModal.show();
        },
        saveHandler() {
            this.$refs.mainModal.hide();
            if (this.model.importAs !== "inline") {
                console.log("this.model.importAs", this.model.importAs);

                this.model.selfClosing = false;
            }
            this.$emit("saved", { old: this.value, new: this.model });
        }
    },
    watch: {
        value(val) {
            this.laodEntry(val);
        }
    }
};
</script>
